import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ResourceTypeLink } from "@evergis/api";
import { Action } from "redux-act";

import { useResourceType } from "../../../hooks/useResourceType";

import { RootState } from "../../../ducks/reducers";

type FilterPayload<T> = { value: T; type: ResourceTypeLink };
type FilterSelector<T> = (resourceType: ResourceTypeLink) => (state: RootState) => T;
type FilterAction<T> = (payload: FilterPayload<T>) => Action<FilterPayload<T>>;
type FilterUpdate<T> = (update: T) => void;

export const useFilter = <T>(selector: FilterSelector<T>, action: FilterAction<T>): [T, FilterUpdate<T>] => {
  const [resourceType] = useResourceType();
  const value = useSelector(selector(resourceType));
  const dispatch = useDispatch();

  const update = useCallback(
    (valueUpdate: T) => dispatch(action({ value: valueUpdate, type: resourceType })),
    [resourceType, action, dispatch],
  );

  return [value, update];
};
